import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <div className="w-20 h-20 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 mb-6 mx-auto">
          <i className="ri-error-warning-line text-3xl"></i>
        </div>
        <h1 className="text-xl md:text-2xl font-heading font-semibold text-foreground-950 mt-6">页面未找到</h1>
        <p className="mt-2 text-base text-foreground-400 font-mono">{location.pathname}</p>
        <p className="mt-4 text-sm text-foreground-500">您访问的页面不存在或已被移除</p>
        <Link
          to="/"
          className="mt-6 inline-flex items-center gap-2 px-6 py-2.5 bg-primary-500 text-white text-sm rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-home-line"></i>
          返回首页
        </Link>
      </div>
    </div>
  );
}